import React from 'react';
import classNames from 'classnames';

import renderIcon from '../../../utils/renderIcon';

const ns = `rewards-points-for-purchase`;

const PointsForPurchase = ({
	price,
}) => {
	if (typeof price !== 'number') return null;

	// Note: at this time brands are aligned with mapping $1 = 1 point
	const points = Math.floor(price);

	// Assumption is all brands will have this same page setup in Shopify
	const rewardsPageUrl = `https://${ process.env.GATSBY_SHOPIFY_STORE_URL }/pages/rewards`;

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<a className={rootClassnames} href={rewardsPageUrl} target={'_blank'} rel={'noreferrer'}>
			<span>
				{'Earn '}
				<span>{ points }</span>
				{' points with this purchase'}
			</span>
			<span aria-hidden>
				{renderIcon('info')}
			</span>
		</a>
	);
};

export default PointsForPurchase;
